// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"e836bd51","745":"87389f1c","787":"4a0b2df5"}[chunkId] + ".chunk.js";
};